var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscontinuedTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "needs_approval_status",
    "data-name": "needs approval status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 23,
    viewBox: "0 0 96 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    fill: "#fbf8f3",
    stroke: "#b47714",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 23,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 95,
    height: 22,
    rx: 4,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Discontinued",
    transform: "translate(14 16)",
    fill: "#b47714",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Discontinued"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscontinuedTag);
export default __webpack_public_path__ + "static/media/discontinued_tag.3c6e35c2b701a540801a66598eeb60a8.svg";
export { ForwardRef as ReactComponent };